import React from 'react'
import { Autocomplete, TextField, InputAdornment, Box } from '@mui/material'
import SportIcon, {
  ICON_OPTIONS,
  ICONTYPE_SDK,
  DEFAULT_ICON_NAME,
  DEFAULT_ICONTYPE,
  isSameIcon,
} from './SportIcon'

const GROUP_LABELS = {
  [ICONTYPE_SDK]: 'Falcon-kuvakkeet',
}

// Dropdown over both icon vocabularies, previewing each icon in the list and in the
// closed field. Reports the selection as { icon, icontype }.
export default function SportIconSelect({ icon, icontype, onChange, label = 'Kuvake', disabled, id }) {
  const current =
    ICON_OPTIONS.find((o) => isSameIcon(o, { name: icon, icontype: icontype || DEFAULT_ICONTYPE })) ||
    ICON_OPTIONS.find((o) => isSameIcon(o, { name: DEFAULT_ICON_NAME, icontype: DEFAULT_ICONTYPE }))
  return (
    <Autocomplete
      id={id}
      options={ICON_OPTIONS}
      value={current}
      onChange={(_e, val) =>
        onChange(
          val
            ? { icon: val.name, icontype: val.icontype }
            : { icon: DEFAULT_ICON_NAME, icontype: DEFAULT_ICONTYPE }
        )
      }
      disabled={disabled}
      disableClearable
      groupBy={(o) => GROUP_LABELS[o.icontype] || 'MUI-kuvakkeet'}
      getOptionLabel={(o) => o.name}
      isOptionEqualToValue={isSameIcon}
      renderOption={(props, option) => (
        <Box component='li' sx={{ display: 'flex', gap: 1, alignItems: 'center' }} {...props}>
          <SportIcon name={option.name} icontype={option.icontype} fontSize='small' />
          {option.name}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant='standard'
          fullWidth
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position='start'>
                <SportIcon name={current.name} icontype={current.icontype} fontSize='small' />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  )
}
